import { darken, transparentize } from 'polished'
import styled from 'styled-components'

export const RouteListItemStyled = styled.div`
  li {
    display: grid;
    grid-template-areas: 'bullet label delete';
    grid-template-columns: auto 1fr auto;
    gap: 1rem;
    align-items: center;

    .bullet {
      display: grid;
      justify-items: center;
      padding-left: 1rem;

      &::after,
      &::before {
        content: '';
        background-color: ${({ theme }) => theme.colors.primary};
        width: 3px;
        height: 10px;
      }

      &.start {
        &:before {
          opacity: 0;
        }
      }

      &.end {
        &:after {
          opacity: 0;
        }
      }

      .icon {
        margin-left: 1px;
      }
    }

    label {
      cursor: grab;
    }

    .delete-btn {
      background: none;
      border: none;
      color: ${({ theme }) => theme.colors.light};
      padding: 0.5rem;
      cursor: pointer;
      transition: 0.5s;
      opacity: 0;
      margin-right: 0.5rem;

      &:hover {
        color: ${({ theme }) => theme.colors.danger};
      }
    }

    &:hover {
      .delete-btn {
        opacity: 1;
      }
    }

    &.active,
    &:hover {
      background: ${({ theme }) => darken(0.05, theme.colors.background)};
      box-shadow: 0 5px 5px
          ${({ theme }) => transparentize(0.9, theme.colors.dark)} inset,
        0 -5px 5px ${({ theme }) => transparentize(0.9, theme.colors.dark)} inset;
    }

    &.active {
      .icon {
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }

  @media only screen and (max-width: ${({ theme }) => theme.responsive.small}) {
    li {
      gap: 0.5rem;

      label {
        display: none;
      }

      .delete-btn {
        display: none;
        opacity: 1;
      }

      &.active {
        margin-left: 3px;
        padding: 10px;
        width: 1.5rem;
        border-radius: 1.5rem;
        background-color: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.light};
        display: grid;

        .icon {
          display: none;
        }

        .bullet {
          display: none;
        }

        label {
          display: grid;
          align-content: center;

          .number {
            font-weight: bold;
          }

          .text {
            display: none;
          }
        }

        .delete-btn {
          display: block;
          opacity: 1;
          padding: 0;
          margin-right: 5px;
        }
      }
    }
  }
`
